import React, { useState, useEffect } from 'react';
import { SectionHeader, BfiCustomStore, Accordion } from '../common/SharedComponents';
import store, { searchActions } from '@apply/adminStore';
import { useSelector } from 'react-redux';
import debounce from 'lodash.debounce';
import { UserNoticeSectionType, UserNoticeSectionTypeOptions, UserNoticeSubSectionTypeOptions } from '@apply/constants';
import NoticesSearchTable from './tables/NoticesSearchTable';
import { FeatureType } from '@apply/constants';
import { Navigate } from 'react-router-dom';
import ViewNoticeModal from './modals/ViewNoticeModal';
import AddNoticeModal from './modals/AddNoticeModal';
import DeclineOrRecycleModal from '../applications/common/modals/DeclineOrRecycleModal';
import LoseLoanModal from '../loans/modals/LoseLoanModal';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSearch } from '@fortawesome/free-solid-svg-icons';

const NoticesLanding = () => {
    const searchState = useSelector((state) => state.searchState);
    const { dispatch } = store;
    const { user } = store.getState();
    const debouncedSearch = debounce(dispatch, 500);
    const [sectionId, set_sectionId] = useState(UserNoticeSectionType.Open);
    const [subSections, set_subSections] = useState([]);

    const noticesGridStore = new BfiCustomStore();

    const _onSearchChange = (event) => {
        debouncedSearch(
            searchActions.setSearchText({
                searchText: {
                    ...searchState.searchText,
                    notices: event.target.value,
                },
            })
        );
    };

    useEffect(() => {
        var selectedSubSections = UserNoticeSubSectionTypeOptions.filter((element) => element.sectionId === sectionId);
        set_subSections(selectedSubSections);
    }, [sectionId]);

    const isFeatureEnabled = () => {
        if (!user || !user.featureList) {
            return false;
        }
        const feature = user.featureList.find((f) => f.featureId === FeatureType.Notices);
        return feature?.isEnabled ?? false;
    };

    if (!isFeatureEnabled()) {
        return <Navigate to={`/adminreferral`} />;
    }

    return (
        <>
            <SectionHeader title='User Notices' />
            <div
                className='main-content'
                style={{ padding: 0, backgroundColor: '#f4f4f4' }}
            >
                <div>
                    <div
                        style={{
                            width: 'calc(100% - 360px)',
                            borderBottom: '1px solid #cfcfe7',
                            padding: '.5625rem 0 0 0.937rem',
                            height: '58px',
                            position: 'relative',
                            float: 'left',
                        }}
                    >
                        <input
                            type='search'
                            placeholder='Search on BFI Number, Borrower...'
                            defaultValue={searchState?.searchText?.notices}
                            onChange={_onSearchChange}
                            style={{ paddingLeft: '30px' }}
                        />
                        <FontAwesomeIcon
                            icon={faSearch}
                            style={{
                                left: '1.4375rem',
                                position: 'absolute',
                                top: '50%',
                                transform: 'translateY(-50%)',
                            }}
                        />
                    </div>
                    <div
                        className='main-search2'
                        style={{ width: '350px' }}
                    >
                        <select
                            id='sectionId'
                            value={sectionId}
                            onChange={(event) => set_sectionId(parseInt(event.target.value))}
                        >
                            {UserNoticeSectionTypeOptions.sort((a, b) => (a.name > b.name ? 1 : -1)).map((fs) => {
                                return (
                                    <option
                                        key={fs.id}
                                        value={fs.id}
                                    >
                                        {fs.name}
                                    </option>
                                );
                            })}
                        </select>
                    </div>
                </div>
                <div
                    className='scrollable-content'
                    style={{ padding: '1rem' }}
                >
                    <div
                        className='applications accordion'
                        data-accordion=''
                        data-allow-all-closed='true'
                        data-multi-expand='true'
                    >
                        {subSections &&
                            subSections.length > 0 &&
                            subSections.map((ss) => {
                                return (
                                    <Accordion
                                        key={ss.sectionId + ss.subSelectionId + ss.name}
                                        title={ss.name}
                                    >
                                        <div className='card'>
                                            <div className='card-section'>
                                                <NoticesSearchTable
                                                    subSection={ss}
                                                    gridStore={noticesGridStore}
                                                />
                                            </div>
                                        </div>
                                    </Accordion>
                                );
                            })}
                    </div>
                </div>
            </div>
            <ViewNoticeModal />
            <AddNoticeModal />
            <DeclineOrRecycleModal />
            <LoseLoanModal />
        </>
    );
};

export default NoticesLanding;
